module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Wassereinbruch.8b1d36a6.svg";